export enum StepType {
    COMPLETE,
    ACTIVE,
    TODO
}